import { Map } from 'immutable';
import 'prop-types';
import '@dbh/hotels-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

/**
 * Returns the `GA4` native `view_item_list` event in `analyticsEventSent`
 * format, for the hotels shown in search results pages.
 * @param {Object} options .
 * @param {Immutable.List<Immutable.Map>} options.hotels .
 * @param {Object} options.searchLocationCoordinates .
 * @return {Immutable.Map} .
 * @see {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=10203824956579507532-EU&client_type=gtag#view_item_list_item}
 */const createAnalyticsEventViewItemList=withConformsTo("createAnalyticsEventViewItemList",[],a=>{let{hotels:b,searchLocationCoordinates:c}=a;return Map({eventPastTense:"view_item_list",lat:null===c||void 0===c?void 0:c.lat,lng:null===c||void 0===c?void 0:c.lng,items:b.map((a,b)=>{var c,d;return Map({item_id:a.get("id"),item_name:a.get("name"),index:b+1,...(null===(c=a.get("packageCategories"))||void 0===c?void 0:c.reduce((a,b,c)=>4<c?a:(a["item_category".concat(0===c?"":c+1)]=b.get("reference"),a),{})),location_id:a.get("address"),price:a.get("minPrice"),quantity:null===(d=a.get("packages"))||void 0===d?void 0:d.size})})})});

export { createAnalyticsEventViewItemList as default };
